<template>
  <div class="vertical-center push-down">
    <div class="center">
      <img id="animation" class="button" src="../assets/ani1frame.png" alt="Animation" />
    </div>
  </div>
</template>
<script>
import simulation from "../modules/Simulation"

export default {
  name: "Animation",
  methods: {
    player(id, timeout, fn) {
      let image = new Image(),
        tm,
        element = document.getElementById(id),
        clickHandler = () => {
          if (tm) {
            clearTimeout(tm)
          }
          element.removeEventListener("click", clickHandler)
          if (fn) {
            fn()
          }
        },
        startHandler = (evt) => {
          if (evt.target instanceof Image) {
            element.src = image.src
            element.removeEventListener("click", startHandler)
            element.addEventListener("click", clickHandler)
            tm = setTimeout(() => {
              clickHandler()
            }, timeout)
          }
        }
      image.src = require("../assets/animation.gif")
      image.onload = () => {
        element.addEventListener("click", startHandler)
      }
    },
  },
  created() {
    simulation.mode =
      this.$route.query.simulate === null
        ? "production"
        : this.$route.query.simulate
  },
  mounted() {
    let header = document.getElementById("header"),
      logo = document.getElementById("logo")
    if (!header.classList.contains("hidden")) {
      header.classList.add("hidden")
    }
    if (!logo.classList.contains("hidden")) {
      logo.classList.add("hidden")
    }
    this.player("animation", 9500, () => {
      document.getElementById("header").classList.remove("hidden")
      document.getElementById("logo").classList.remove("hidden")
      this.$router.push("/lang")
    })
  },
}
</script>
<style scoped>
.center {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.button {
  height: auto;
  width: 100%;
  cursor: pointer;
}
</style>